var outScope = new Object()
var arrayProps = new Array()
var arrayPropsId = new Array()
var dataObj = {
  communities: [
    {
      title: 'Arbors at Brighton Park',
      address: '627 Brighton Park Way',
      city: 'Bloomfield, CT',
      zip: '06002',
      phone: '860.431.3367',
      thumbnail: '/assets/img/properties/thumbnails/thumb_arbors.jpg',
      slug: 'arbors-at-brighton-park',
      coord: {
        lat: 41.8553565,
        lng: -72.7287389
      },
      apiName: 'the-arbors-at-brighton-park',
      nearby: [
        'rivers-edge',
        'windsor-crossing'
      ]
    }, {
      title: 'Spinnaker Milford',
      address: '3 Schooner Lane',
      city: 'Milford, CT',
      zip: '06460',
      phone: '475.241.7803',
      thumbnail: '/assets/img/properties/thumbnails/thumb-spinnaker-milford.jpg',
      slug: 'spinnaker-milford',
      coord: {
        lat: 41.221360,
        lng: -73.055950
      },
      apiName: 'spinnaker-milford',
      nearby: [
        'the-royce-at-trumbull',
        'soundview-at-savin-rock'
      ]
    }, {
      title: 'Spinnaker Brook',
      address: '158 Cherry Street',
      city: 'Milford, CT',
      zip: '06460',
      phone: '475.241.7925',
      thumbnail: '/assets/img/properties/thumbnails/thumb_spinnaker-brook.jpg',
      slug: 'spinnaker-brook',
      coord: {
        lat: 41.2287,
        lng: -73.0507
      },
      apiName: 'spinnaker-brook',
      nearby: ['cambridge-oxford', 'soundview-at-savin-rock']
    }, {
      title: 'Spinnaker Chase',
      address: '68-70 West Main Street',
      city: 'Milford, CT',
      zip: '06460',
      phone: '475.241.7925',
      thumbnail: '/assets/img/properties/thumbnails/thumb_spinnaker-chase.jpg',
      slug: 'spinnaker-chase',
      coord: {
        lat: 41.2274,
        lng: -73.0607
      },
      apiName: 'spinnaker-chase',
      nearby: ['cambridge-oxford', 'soundview-at-savin-rock']
    }, {
      title: 'Spinnaker Crest',
      address: '79 Noble Avenue',
      city: 'Milford, CT',
      zip: '06460',
      phone: '475.241.7925',
      thumbnail: '/assets/img/properties/thumbnails/thumb_spinnaker-crest.jpg',
      slug: 'spinnaker-crest',
      coord: {
        lat: 41.2179,
        lng: -73.0624
      },
      apiName: 'spinnaker-crest',
      nearby: ['cambridge-oxford', 'soundview-at-savin-rock']
    }, {
      title: 'Spinnaker Falls',
      address: '41 Prospect Street',
      city: 'Milford, CT',
      zip: '06460',
      phone: '475.241.7925',
      thumbnail: '/assets/img/properties/thumbnails/thumb_spinnaker-falls.jpg',
      slug: 'spinnaker-falls',
      coord: {
        lat: 41.2245,
        lng: -73.0553
      },
      apiName: 'spinnaker-falls',
      nearby: ['cambridge-oxford', 'soundview-at-savin-rock']
    }, {
      title: 'Spinnaker Green',
      address: '120-150 Washington Street',
      city: 'Milford, CT',
      zip: '06460',
      phone: '475.241.7925',
      thumbnail: '/assets/img/properties/thumbnails/thumb_spinnaker-green.jpg',
      slug: 'spinnaker-green',
      coord: {
        lat: 41.217,
        lng: -73.0745
      },
      apiName: 'spinnaker-green',
      nearby: ['cambridge-oxford', 'soundview-at-savin-rock']
    }, {
      title: 'Spinnaker Hunt',
      address: '253 W River Street',
      city: 'Milford, CT',
      zip: '06460',
      phone: '475.241.7929',
      thumbnail: '/assets/img/properties/thumbnails/thumb_spinnaker-hunt.jpg',
      slug: 'spinnaker-hunt',
      coord: {
        lat: 41.2334,
        lng: -73.0589
      },
      apiName: 'spinnaker-hunt',
      nearby: ['cambridge-oxford', 'soundview-at-savin-rock']
    }, {
      title: 'Spinnaker Square',
      address: '42-56 South Broad Street',
      city: 'Milford, CT',
      zip: '06460',
      phone: '475.241.7925',
      thumbnail: '/assets/img/properties/thumbnails/thumb_spinnaker-square.jpg',
      slug: 'spinnaker-square',
      coord: {
        lat: 41.2218,
        lng: -73.0576
      },
      apiName: 'spinnaker-square',
      nearby: ['cambridge-oxford', 'soundview-at-savin-rock']
    }, {
      title: 'Spinnaker Station',
      address: '33-65-75 Railroad Avenue',
      city: 'Milford, CT',
      zip: '06460',
      phone: '475.241.7925',
      thumbnail: '/assets/img/properties/thumbnails/thumb_spinnaker-station.jpg',
      slug: 'spinnaker-station',
      coord: {
        lat: 41.2215,
        lng: -73.0622
      },
      apiName: 'spinnaker-station',
      nearby: ['cambridge-oxford', 'soundview-at-savin-rock']
    }, {
      title: 'Spinnaker Walk',
      address: '60 South Broad Street',
      city: 'Milford, CT',
      zip: '06460',
      phone: '475.241.7925',
      thumbnail: '/assets/img/properties/thumbnails/thumb_spinnaker-walk.jpg',
      slug: 'spinnaker-walk',
      coord: {
        lat: 41.2214,
        lng: -73.0581
      },
      apiName: 'spinnaker-walk',
      nearby: ['cambridge-oxford', 'soundview-at-savin-rock']
    }, {
      title: 'Spinnaker Wharf',
      address: '1 Schooner Lane',
      city: 'Milford, CT',
      zip: '06460',
      phone: '475.241.7925',
      thumbnail: '/assets/img/properties/thumbnails/thumb_spinnaker-wharf.jpg',
      slug: 'spinnaker-wharf',
      coord: {
        lat: 41.2215,
        lng: -73.0558
      },
      apiName: 'spinnaker-wharf',
      nearby: ['cambridge-oxford', 'soundview-at-savin-rock']
    }, {
      title: 'Cambridge Oxford',
      address: '32 High Street',
      city: 'New Haven, CT',
      zip: '06510',
      phone: '475.234.3941',
      thumbnail: '/assets/img/properties/thumbnails/thumb_arbors.jpg',
      slug: 'cambridge-oxford',
      coord: {
        lat: 41.307461,
        lng: -72.931148
      },
      apiName: 'cambridge-oxford',
      nearby: [
        'the-royce-at-trumbull',
        'soundview-at-savin-rock'
      ]
    },
    {
      title: 'Parallel 41',
      address: '1340 Washington Blvd',
      city: 'Stamford, CT',
      zip: '06902',
      phone: '877.496.5025',
      thumbnail: '/assets/img/properties/thumbnails/thumb_parallel-41.jpg',
      slug: 'parallel-41',
      coord: {
        lat: 41.05800139999999,
        lng: -73.54392339999998
      },
      apiName: 'parallel-41',
      nearby: [
        'the-royce-at-trumbull'
      ]
    },
    {
      title: 'Soundview at Savin Rock',
      address: '1 Campbell Avenue',
      city: 'West Haven, CT',
      zip: '06516',
      phone: '203.577.5437',
      thumbnail: '/assets/img/properties/thumbnails/thumb_soundview.jpg',
      slug: 'soundview-at-savin-rock',
      coord: {
        lat: 41.2592447,
        lng: -72.94483439999999
      },
      apiName: 'soundview-apartments',
      nearby: [
        'the-royce-at-trumbull'
      ]
    },
    {
      title: 'The Foundry',
      address: '680 3rd Ave',
      city: 'West Haven, CT',
      zip: '06516',
      phone: '203.469.6337',
      thumbnail: '/assets/img/properties/thumbnails/thumb_foundry.jpg',
      slug: 'the-foundry',
      coord: {
        lat: 41.279655,
        lng: -72.9467984
      },
      apiName: 'foundry-colonial',
      nearby: [
        'soundview-at-savin-rock',
        'brook-hollow'
      ]
    },
    {
      title: 'Colonial Court',
      address: '842 1st Avenue',
      city: 'West Haven, CT',
      zip: '06516',
      phone: '203.469.6337',
      thumbnail: '/assets/img/properties/thumbnails/thumb_colonial-court.jpg',
      slug: 'colonial-court',
      coord: {
        lat: 41.28584499999999,
        lng: -72.95466069999998
      },
      apiName: 'foundry-colonial',
      nearby: [
        'soundview-at-savin-rock',
        'brook-hollow'
      ]
    },
    {
      title: 'Rivers Edge',
      address: '37 Sharon Rd',
      city: 'Waterbury, CT',
      zip: '06705',
      phone: '203.439.5448',
      thumbnail: '/assets/img/properties/thumbnails/thumb_rivers-edge.jpg',
      slug: 'rivers-edge',
      coord: {
        lat: 41.568038,
        lng: -73.000068
      },
      apiName: 'rivers-edge-1',
      nearby: [
        'the-royce-at-trumbull'
      ]
    },
    {
      title: 'Brook Hollow',
      address: '430 Eastern St',
      city: 'New Haven, CT',
      zip: '06513',
      phone: '475.234.2582',
      thumbnail: '/assets/img/properties/thumbnails/thumb_brook-hollow.jpg',
      slug: 'brook-hollow',
      coord: {
        lat: 41.31850379999999,
        lng: -72.87175509999997
      },
      apiName: 'brook-hollow-0',
      nearby: [
        'the-fairways',
        'the-foundry'
      ]
    },
    {
      title: 'Woodbury Knoll',
      address: '302 Tuttle Rd',
      city: 'Woodbury, CT',
      zip: '06798',
      phone: '203.872.5695',
      thumbnail: '/assets/img/properties/thumbnails/thumb_woodbury-knoll.jpg',
      slug: 'woodbury-knoll',
      coord: {
        lat: 41.527686,
        lng: -73.18186600000001
      },
      apiName: 'woodbury-knoll',
      nearby: [
        'rivers-edge',
        'the-royce-at-trumbull'
      ]
    },
    {
      title: 'The Fairways',
      address: '80 Eastern St',
      city: 'New Haven, CT',
      zip: '06513',
      phone: '475.224.4716',
      thumbnail: '/assets/img/properties/thumbnails/thumb_fairways.jpg',
      slug: 'the-fairways',
      coord: {
        lat: 41.3097388,
        lng: -72.8737888
      },
      apiName: 'fairway-apartments-0',
      nearby: [
        'brook-hollow',
        'the-foundry'
      ]
    },
    {
      title: 'Windsor Crossing',
      address: '40 Barry Circle',
      city: 'Bloomfield, CT',
      zip: '06002',
      phone: '203.437.6152',
      thumbnail: '/assets/img/properties/thumbnails/thumb_windsor-crossing.jpg',
      slug: 'windsor-crossing',
      coord: {
        lat: 41.8364038,
        lng: -72.69713939999997
      },
      apiName: 'windsor-crossing',
      nearby: [
        'rivers-edge',
        'woodbury-knoll'
      ]
    }
  ]
};

// Only display nearby communities in each individual community page
$(function () {
  if (window.location.href.indexOf('communities/') === -1) {
    return
  }

    dataObj.communities.filter((community) => {
      if (community.slug === window.location.href.split('communities/')[1].split('/')[0]) {
        const allCommunities = $('.section__nearby-communities figure')

        allCommunities.addClass('hidden')

        for (var i = 0; i < allCommunities.length; i++) {
          if ($(allCommunities[i]).hasClass(community.nearby[0])) {
            $(allCommunities[i]).removeClass('hidden')
          } else if ($(allCommunities[i]).hasClass(community.nearby[1])) {
            $(allCommunities[i]).removeClass('hidden')
          } else if ($(allCommunities[i]).hasClass(community.nearby[2])) {
            $(allCommunities[i]).removeClass('hidden')
          } else {};
        };
      };
    })
})

$(function () {
  var reqType = 'searchJSON'
  // This is the paredim token
  var apiToken = 'OTE3OTQ%3d-%2fHH8lAE20PQ%3d'
  var url = 'https://api.rentcafe.com/rentcafeapi.aspx'

// https://api.rentcafe.com/rentcafeapi.aspx?apiToken=OTE3OTQ%3d-%2fHH8lAE20PQ%3d&requestType=searchJSON

  $.ajax({
    async: true,
    crossDomain: true,
    url: url + '?apiToken=' + apiToken + '&requestType=' + reqType,
    method: 'GET',
    dataType: 'json',
    headers: {
      // 'cache-control': 'no-cache',
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  }).done(function (response) {
    const eachProp = Object.keys(response).map(function (itm) {
      return response[itm]
    })
    eachProp.forEach((e, i) => {
      let propId = e.Propertyid
      let propName = e.propertyShortName
      let propRent = e.minrent

      arrayProps[i] = {
        [propName]: propRent
      }

      arrayPropsId[i] = {
        [propId]: propRent
      }
    })

    outScope.propsArray = arrayProps

    $('.featured-community__rent, .community__rent').each(function (i, domElement) {
      for (var j = 0; j < arrayProps.length; j++) {
        let keyName = Object.keys(arrayProps[j])
        if (domElement.classList.contains(keyName) && arrayProps[j][keyName] >= 500) {
          domElement.innerHTML = `Starting at <strong>\$${numberWithCommas(arrayProps[j][keyName])} </strong>*`
        } else if (domElement.classList.contains(undefined)) {
          domElement.innerHTML = 'Call For Pricing'
        }
      }
    })

    dataObj.communities.forEach((rootJSON, i) => {
      for (var j = 0; j < outScope.propsArray.length; j++) {
        if (dataObj.communities[i].apiName == Object.keys(outScope.propsArray[j])) {
          dataObj.communities[i].rent = Object.keys(outScope.propsArray[j]).map(function (itm) {
            return outScope.propsArray[j][itm]
          })
        }
      }
      if (!dataObj.communities[i].apiName || dataObj.communities[i].rent <= 500) {
        dataObj.communities[i].rent = ['Call For Pricing']
      }
    })
  }).done(function (response) {
    const eachProp = Object.keys(response).map(function (itm) {
      return response[itm]
    })
    // Begin API call to dinamically populate the flooplans prices
    // https://api.rentcafe.com/rentcafeapi.aspx?apiToken=OTE3OTQ%3d-%2fHH8lAE20PQ%3d&requestType=floorPlan&propertyId=<PROPIDGOESHERE>
    eachProp.forEach((e, i) => {
      var reqType = 'floorPlan'
      var apiToken = 'OTE3OTQ%3d-%2fHH8lAE20PQ%3d'
      var pid = e.Propertyid
      var url = 'https://api.rentcafe.com/rentcafeapi.aspx'

      $.ajax({
        async: true,
        crossDomain: true,
        url: url + '?apiToken=' + apiToken + '&requestType=' + reqType + '&propertyId=' + pid,
        method: 'GET',
        dataType: 'json',
        headers: {
          // 'cache-control': 'no-cache',
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      }).then(function (response) {
        response.forEach((e, i) => {
          if (!e.MinimumSQFT) {} else if (parseInt(e.MinimumRent) <= 500) {} else {
            $(`[data-fpid="${e.FloorplanId}"][ data-prop="${e.PropertyId}"]`).empty()
            $(`[data-fpid="${e.FloorplanId}"][ data-prop="${e.PropertyId}"]`).html(`Starting at: \$${numberWithCommas(e.MinimumRent)}`)
          }
        })
      })
    })
  })

  const numberWithCommas = (x) => {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
  }

  // $.getJSON('/assets/data/map-data.json', function (data) {
  //   dataObj = data
  // })

  setTimeout(function () {
    propertyLoop(dataObj.communities)
  }, 1000)

  var propertyLoop = function (data) {
    var cityTypeArray = []
    var priceTypeArray = []
    var cities = $('#city')
    var price = $('#hightolow')
    for (var i = 0; i < data.length; i++) {
      if (cityTypeArray.indexOf(data[i].city) === -1) {
        cityTypeArray.push(data[i].city)
      } else {};
      if (priceTypeArray.indexOf(data[i].rent) === -1) {
        priceTypeArray.push(data[i].rent)
      } else {};
    }
    for (var i = 0; i < cityTypeArray.length; i++) {
      cities.append('<option>' + cityTypeArray[i] + '</option>')
    }
  }

  var bindData = function (data) {
    var el = $('#diff-comm')
    el.empty()
    for (var i = 0; i < data.length; i++) {
      var formattedPrice = numberWithCommas(data[i].rent)

      el.append('<figure class="community__card"><a href="/communities/' + data[i].slug + '"><div class="community__thumbnail" style="background-image:url(' + data[i].thumbnail + ')"></div><ul class="community__info"><li><h3 class="community__name">' + data[i].title + '</h3></li><li class="community__place">' + data[i].city + '</li><li class="community__rent ' + data[i].apiName + '">Starting at $' + data[i].rent + '<sup>*</sup></li><li class="community__phone"><a href="tel: ' + data[i].phone + '">' + data[i].phone + '</a></li></ul></a><a class="community-card__apply-link" href="' + data[i].apply + '" target="_blank">Apply Now</a></figure>')
    }
  }

  $('#hightolow').on('change', function () {
    var selected = $(this).val()
    var byPrice = dataObj.communities.slice(0)
    if (selected == 'high') {
      byPrice.sort(function (a, b) {
        return parseFloat(b.rent[0].toString().replace(/,/g, '')) - parseFloat(a.rent[0].toString().replace(/,/g, ''))
      })
    } else if (selected == 'low') {
      byPrice.sort(function (a, b) {
        return parseFloat(a.rent[0].toString().replace(/,/g, '')) - parseFloat(b.rent[0].toString().replace(/,/g, ''))
      })
    } else {
      return
    }
    bindData(byPrice)
    $('.community__rent.undefined').html('Call For Pricing')
  })

  $('#city').on('change', function () {
    var selected = $(this).val().toUpperCase()
    var byCity = dataObj.communities.slice(0)
    byCity.sort(function (a, b) {
      if (a.city < b.city) {
        return -1
      }
      if (a.city > b.city) {
        return 1
      }
      return 0
    })
    for (var i = 0; i < byCity.length; i++) {
      if (byCity[i].city.toUpperCase() == selected) {
        var hailMary = byCity[i]
        byCity.splice(i, 1)
        byCity.unshift(hailMary)
      } else {};
    };
    bindData(byCity)
    $('.community__rent.undefined').html('Call For Pricing')
  })

})



// WEBPACK FOOTER //
// ./src/assets/js/dynamic-pricing.js